import { FC, memo } from 'react';

import Link from 'next/link';

import { useRecoilValue, useSetRecoilState } from 'recoil';

import { cvPointAtom } from '@recoil_iqfu/atoms/public/cv_point';
import { sellerIsLoggedIn } from '@recoil_iqfu/atoms/public/login_state';

import styles from './SecondaryCTA.module.scss';

type Props = {
  internalLink?: {
    path: string;
    text: string;
  };
  inFirstView?: boolean;
  withYellowBackground?: boolean;
};

const SecondaryCTA: FC<Props> = memo(({ internalLink, inFirstView, withYellowBackground = true }) => {
  const isLoggedIn = useRecoilValue(sellerIsLoggedIn);

  const setCvPoint = useSetRecoilState(cvPointAtom);

  return (
    <div className={`${withYellowBackground ? styles.with_background : ''} ${styles.container}`}>
      <div className={styles.lead_container}>
        <h2 className={styles.lead_text}>売却でお悩み中のあなたへ</h2>
      </div>

      <div className={styles.content_area}>
        <div className={styles.circle_label}>
          <div>
            <span className={styles.pc_only}>相談</span>
            <br className={styles.pc_only} />
            無料
          </div>
        </div>

        <h3 className={styles.content_area_headding}>
          イクラ<span className={styles.highlight}>ならでは</span>
          <span className={styles.small}>のサポート</span>
        </h3>

        <div className={styles.content_area_list_container}>
          <img
            className={styles.ikuko_support}
            src="/images/iqfu/public/cta/ikuko_support.png"
            alt=""
            loading={inFirstView ? 'eager' : 'lazy'}
          />
          <img
            className={`${styles.cta_buildings} pc_only`}
            src="/images/iqfu/public/cta/cta_buildings.png"
            alt=""
            loading={inFirstView ? 'eager' : 'lazy'}
          />

          <ul className={styles.content_area_list}>
            <li className={styles.content_area_list_item}>
              売却に関するお悩みを
              <br className="sp_only" />
              <span className={styles.highlight}>専門スタッフに相談できる</span>
            </li>
            <li className={styles.content_area_list_item}>
              チャットだから、
              <br className="sp_only" />
              <span className={styles.highlight}>自分のタイミングで返信できる</span>
            </li>
            <li className={styles.content_area_list_item}>
              <span className={styles.highlight}>全国20万件以上の売却実績データ</span>
              をもとに、売却に強い不動産会社をご紹介
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.cv_button_area_container}>
        <div className={styles.cv_button_area}>
          {internalLink?.path && internalLink?.text && (
            <Link
              href={internalLink?.path}
              className={styles.cv_companies_link}
              dangerouslySetInnerHTML={{
                __html: internalLink?.text,
              }}
            ></Link>
          )}

          <Link
            href={isLoggedIn ? '/chat/talk?redirect=contact' : '/signup_inquiry'}
            className={styles.cv_chat_link}
            onClick={() => {
              setCvPoint('CTA');
            }}
          >
            <span className={styles.highlight}>無料</span>専門スタッフに相談する
          </Link>
        </div>
      </div>
    </div>
  );
});

SecondaryCTA.displayName = 'SecondaryCTA';

export default SecondaryCTA;
